'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from 'angular';


export default function projectPlanFundByYearTable() {
    return {
        restrict: 'A',
        template: require('../view/table.html'),
        transclude: false,
        scope: {
            selectedItem: '=?myValue',
            items: '=?myItems',
            type: '@myType',
            filters: '=?myFilters',
            ok: '=?myOk',
            isPaging: '=myPagination',
            isSearch: '=mySearching',
            isFilter: '=myFilter',
            project: '=myProject',
            edit: '=edit',
            changed: '=?myChanged',
        },
        controller: ['$scope', '$routeParams', '$utils', '$uibModal',
                     function($scope, $routeParams, $utils, $modal) {
                         $scope.getTotal = getTotal;
                         $scope.dblClick = dblClick;
                         $scope.select = select;
                         $scope.isSelect = isSelect;
                         $scope.getItems = getItems;
                         $scope.getValue = $utils.getValue;
                         $scope.refresh = refresh;

                         if (!$scope.selectedItem) {
                             $scope.selectedItem = {};
                         }

                         $scope.columns = [{
                             name: 'Год',
                             data: 'year',
                         }, {
                             name: 'Сумма',
                             data: 'amount',
                         }];

                         $scope.searching = {
                             isSearch: $scope.isSearch,
                             filter: null,
                         };

                         $scope.pagination = {
                             isPaging: $scope.isPaging,
                             page: 1,
                             size: $scope.isPaging ? 10 : null,
                             totalPages: null,
                             totalItems: null,
                         };

                         $scope.toolbox = {
                             buttons: {
                                 create: {
                                     show: () => $scope.edit,
                                     click: () => {
                                         $modal.open({
                                            template: require('../view/project-plan-fund-by-year-modal-create.html'),
                                            controller: 'ProjectPlanFundByYearModalCreateController',
                                            size: 'md',
                                            backdrop: false,
                                            resolve: {
                                                planFundByYear: function() {
                                                    return {};
                                                },
                                                edit: function() {
                                                    return $scope.edit;
                                                },
                                            },
                                        }).result.then(function(data) {
                                             if (!$scope.items.some((item) => equals(item, data))) {
                                                 $scope.items.push(data);
                                             }
                                         });
                                     },
                                     disabled: () => false,
                                 },
                                 edit: {
                                     show: () => true,
                                     click: (item) => {
                                         $modal.open({
                                            template: require('../view/project-plan-fund-by-year-modal-create.html'),
                                            controller: 'ProjectPlanFundByYearModalCreateController',
                                            size: 'md',
                                            backdrop: false,
                                            resolve: {
                                                planFundByYear: function() {
                                                    return item;
                                                },
                                                edit: function() {
                                                    return $scope.edit;
                                                },
                                            },
                                        }).result.then(function(data) {
                                             angular.copy(data, item);
                                             angular.copy(data, $scope.selectedItem);
                                         });
                                     },
                                     disabled: () => !isSelected(),
                                 },
                                 remove: {
                                     show: () => $scope.edit,
                                     click: (item) => {
                                         $scope.items.splice($scope.items.indexOf($scope.items.find((it) => equals(it, item))), 1);
                                         angular.copy({}, $scope.selectedItem);
                                     },
                                     disabled: () => !isSelected(),
                                 },
                                 refresh: {
                                     show: () => false,
                                     click: $scope.refresh,
                                     disabled: () => false,
                                 },
                             },
                         };

                         refresh();

                         function refresh() {
                             if (Array.isArray($scope.items)) {
                                 if ($scope.items.every((i) => !equals(i, data))) {
                                     $scope.selectedItem = {};
                                 }
                             }
                         }

                         function getTotal() {
                             let total = 0.0;

                             if (Array.isArray($scope.items)) {
                                 $scope.items.forEach((item) => {
                                     total += item.amount;
                                 });
                             }

                             return Math.round(total * 100.0) / 100.0;
                         }

                         function dblClick(item) {
                             switch ($scope.type) {
                                 case 'table':
                                     $scope.toolbox.buttons.edit.click(item);
                                     break;
                                 case 'select':
                                     $scope.ok();
                                     break;
                             }
                         }

                         function select(item) {
                             if (!$scope.isSelect(item)) {
                                 $scope.selectedItem = item;
                             } else {
                                 $scope.selectedItem = {};
                             }
                         }

                         function isSelect(item) {
                             return equals($scope.selectedItem, item);
                         }

                         function isSelected() {
                             return $scope.selectedItem != null && $scope.selectedItem.year != null;
                         }

                         function equals(i1, i2) {
                             if (i1 == null || i2 == null) {
                                 return false;
                             }

                             return (i1.year === i2.year);
                         }

                         function getItems() {
                             return $scope.items;
                         }
                     }],
    };
}
